<div class="header">
    <div class="container">
        <div class="row">
            <div class="col-md-8 col-12 order-md-first order-last header-col-one">
                <div class="my-name">
                    <div class="name">
                        <h2>Мурадян Геннадий Александрович</h2>
                        <p>frontend-developer</p>
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-12 order-md-last order-first">
                <div class="photo">
                    <img class="im" src="../../assets/img/Im.jpeg" alt="">
                </div>
            </div>
        </div>
    </div>
</div>
